import IconAsMaskImage from '../IconAsMaskImage'

function Attachment({ pureSvg, className, color, ...rest }) {
  const svg = (
    <svg {...rest} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.25 3.66075V10.5C14.25 13.3995 11.8995 15.75 9 15.75C6.1005 15.75 3.75 13.3995 3.75 10.5V5.7375C3.75 3.8115 5.3115 2.25 7.2375 2.25C9.1635 2.25 10.725 3.8115 10.725 5.7375V10.383C10.725 11.355 9.93675 12.144 8.96475 12.144C7.992 12.144 7.20375 11.355 7.20375 10.383V5.99925"
        stroke="black"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, color }} />
}

export default Attachment
